import React from "react";
import { Card } from "../../components/card/Card";
import Heading from "../../components/heading/Heading";
import { Paragraph } from "../../components/paragraph/Paragraph";

const CardWithNameOrTitle = ({ data }) => {
  const { value, label } = data;
  return (
    <Card className="flex flex-col items-center justify-center p-4 rounded space-y-2 border-2">
      <Heading className="font-bold text-5xl mb-6">{value}</Heading>
      <Paragraph className="text-center">{label}</Paragraph>
    </Card>
  );
};

export default CardWithNameOrTitle;
